<p-dropdown emptyMessage=" " [autoDisplayFirst]="false" #lookupFilter optionLabel="Value" [(ngModel)]="selectedValue" [options]="Options"></p-dropdown>
<div class="p-column-filter-buttonbar p-0 pt-40">
    <button pbutton pripple (click)="ClearFilter()"class="p-button-outlined p-button-sm p-button">
        <span class="p-button-label">{{'List.Filter.Clear'| transloco}}</span>
    </button>
    <button pbutton pripple (click)="ApplyFilter()" class="p-button-sm p-button">
        <span class="p-button-label">{{'List.Filter.Apply'| transloco}}</span>
    </button>
</div>